module.exports = __webpack_public_path__ + "img/zjwx.42f389c4.jpg";